import { getRouteUrl } from './routing';
export const getUrl = (routePattern, parameters) => {
    const result = getRouteUrl({ baseUrl: window.OverDrive?._baseUrl }, routePattern, parameters);
    if (!result) {
        try {
            let message = `Failed to route ${routePattern}`;
            if (parameters != null) {
                const parametersJSON = JSON.stringify(parameters);
                message += ` with parameters ${parametersJSON}`;
            }
            const error = new Error(message);
            if (window.NREUM && window.NREUM.noticeError) {
                window.NREUM.noticeError(error);
            }
            else if (window.console && window.console.error) {
                window.console.error(error);
            }
        }
        catch (e) { }
    }
    return result ?? '';
};
